/* GeneratedContentHash: 9b89c37fb300985bd83bc3aa4caaf85450916ca00632abbdb460d91055bcbdf9 */
import {
	type JiraSideNav as MessagePipe,
	createClientPipeline,
	createServerPipeline,
} from '@post-office/placement-common';
import { type GenerateValidationFor } from '@post-office/validation-types';

import { type MessageTemplateContext } from '../../..';

export type HydrationResult = Record<string, never>;

export type VHydrationResult = GenerateValidationFor<HydrationResult>;

type Pipe = MessagePipe<{
	messageContext: MessageTemplateContext;
	hydrationResult: HydrationResult;
}>;

export const { createRender, createValidate } = createClientPipeline<Pipe>();
export const { createHydrate, createHydrateExample, createTransformMetadata } =
	createServerPipeline<Pipe>();
